// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__24lHy","label":"Completed_label__3Q41U"};